'use strict';

import {gsap} from 'gsap';
import 'moment';

import Handlebars from 'handlebars';
import List from 'list.js';
import { toaster } from '../../_assets/abbott/js/_material';
import { flatValues, reverseValues } from '../../_assets/abbott/js/_payment';

let ListPagination = require('../../../node_modules/list.pagination.js/dist/list.pagination.min.js')

import '../../../odometer/odometer-patched.js';
import ButtonTooltip from '../button-tooltip/button-tooltip';

//TODO: this module really needs a good refactoring, especially if new functionalities are added
export default class ProductDetails {
    constructor() { }

    init() {

        let that = this,
            $productList = '',
            _products = that.getAllProducts(false),
            $tenderSetting = $("#TenderSetting");
 
        that._tenderSetting = JSON.parse($tenderSetting.val());
        that.isInit = false;

        // Initialize Odometer
        $('.odo').each(function () {
            var o = new Odometer({
                el: this,
                value: 0
            });
        });

        new ButtonTooltip();

        // Handlebar helpter to convert to lowercase and get first word in a string
        //needed to assign a class to each flavour
        Handlebars.registerHelper('toLowerCase', function(str) {

            return str.toLowerCase().split(' ')[0];
        });

        // calculate price based from quantity and event listeners
        $('.product-details__row').each(function (i, v) {
            let $this = $(this),
            $price = $this.data('price'),
            $singlePrice = $this.data('single-price'),
            $cartonSize = $this.data('cartonsize'),
            $qty = $this.data('qty'),
            $counterVal = $this.find('.counter-value'),
            $productPrice = $this.find('.product-price__total'),
            prodTotal = $price * $qty;

            prodTotal = that.calculateProductTotal($price, $singlePrice, $qty, $cartonSize);

            prodTotal = prodTotal.toFixed(2);

            $counterVal.val($qty);
            $productPrice.text(prodTotal);
        });

        // Display total price for each
        that.updateProducts();

        //handle number of orders
        $('.phase--wrapper.active .product-details').find('.product-details__header .counter-value').on("change", function(e) {
            let noOfOrders = $(this).val();
            if(that._tenderSetting.QuantityType == "CartonSize") {
                if(noOfOrders == 1) {
                    $('.product-details__row .counter-value').removeAttr("readonly");
                } else {
                    $('.product-details__row .counter-value').each(function(idx, itm){
                        let qty = $(itm).val();
                        let incVal = $(itm).data("quantity-increment");
                        if(qty % incVal != 0){
                            $(itm).val(incVal);
                        }
                    });
                    $('.product-details__row .counter-value').attr("readonly", "readonly");
                    that.calculatePricePerProduct();
                    that.updatePayment();
                    that.calculateTotalGst();
                }
            }
        });

        // remove entire product from list
        $('body').on('click', '.js-remove-product', function (e) {
            e.preventDefault();

            let $this = $(this),
            $product = $this.closest('.product-details__row');

            $product.slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function() {
                    $product.remove();

                    that.updateProducts();
                    that.updatePayment();
                }
            });
        });

        // display product list
        $('.js-select-products').on('click', function (e) {
            e.preventDefault();

            let $this = $(this),
                $parent = $this.parent().closest('.add-products__enclosure'),
                $list = $parent.siblings('.products-list__wrap'),
                isFirstOrderOverride = $('.first-order').is(':visible'),
                isViewOrder = $('.view-order').length;

            //TODO: consider refactoring. This was a quick way to deal with SOH with the current codebase
             if(isFirstOrderOverride /*|| isViewOrder//what is this? why?*/){
                $list.slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });
                return false;
            }

            // Get the list of products
            that.displayAllProducts($this, $parent, $list);
        });

        // filter tabs on product list
        $('body').on('click', '.js-filter-click', function(e){
            e.preventDefault();

            var $this = $(this);

            $this.parent().find('.active').removeClass('active');
            $this.addClass('active');

            // Get the value of current tab
            let $category = $this.data('value');

            // If Show all then reset fiter
            if($category === 'Show all') {
                that.$productList.filter();
                return true;
            }

            // If not then filter the list using defined data attributes
            that.$productList.filter(function($item) {

                if($item.values().category === $category) {
                    return true;
                } else {
                    return false;
                }
            });
        });

        // hide product list
        $('.js-close-list').on('click', function (e) {
            e.preventDefault();

            let $this = $(this),
            $list = $this.closest('.products-list__wrap'),
            $addBtn = $list.siblings('.add-products__enclosure'),
            isFirstOrderOverride = $('.first-order').is(':visible'),
            isViewOrder = $('.view-order').length;

            $addBtn.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            $list.slideUp('500', 'easeOutExpo',  function() {

                //TODO: consider refactoring. This was a quick way to deal with SOH with the current codebase
                if(isFirstOrderOverride || isViewOrder)
                    return false;

                // Remove the product list markup to avoid duplicate elements
                $list.find('.products-listing__wrapper').html('');
            });
        });


        $('body').on('click', '.js-add-product', function(e) {
            e.preventDefault();

            that.addProduct($(this), false);
        });

        
        $("body").on("mouseover", ".discount-icon", function(e){
            let $this = $(this),
                content = $this.data("title");
            if($this.find('.tooltip').length > 0)
                return false;

            $('<div class="tooltip">' + content + '<div>')
                .appendTo($this)
                .hide()
                .fadeIn();
        });

        $("body").on("mouseout", ".discount-icon", function(e){
            let $this = $(this);
            if($this.find('.tooltip').length == 0)
                return false;

            window.setTimeout(()=>{
                $this.find('.tooltip')
                    .fadeOut()
                    .remove();
            }, 500);
        });

        // TODO: refaxctor when time
        //change values on hover
        $('body').on('mouseover', '.flavours-listing li ', function() {

            let $this = $(this);

            if ($this.closest('.products-listing__wrapper').length) {
                $this.closest('.container').find('img.product-image').attr('src', $(this).data('image'));
            } else {
                let $selectedFlavour = $this.closest('.product-flavour').find('.product-flavour--selected'),
                    $selectedStockUnits = $this.closest('.product-flavour').find('.stock-quantity__units'),
                    $selectedProduct = $this.closest('.product-flavour-quantity__enclosure'),
                    inStock = $this.attr('data-in-stock'),
                    prodId = $this.data("prod-id");

                $this.closest('.product-details__row').find('.product-description__image img').attr('src', $this.data('image'));
                $selectedFlavour.text($this.data('name'));
                $selectedStockUnits.text(inStock);

                //show this flavours stocks;
                if($this.data('name') == "Mixed") {
                    prodId = 'mixed'
                }
                $this.closest(".product-details__row").find(".stock-counts").addClass("hide");
                $this.closest(".product-details__row").find(`.stock-counts[data-prod-id=${prodId}]`).removeClass("hide");

                that.isOutOfStockLabel(inStock, $selectedProduct);
            }
        }).on('mouseout', '.flavours-listing li ', function() {

            let $this = $(this);

            if($this.is('.selected'))
                return false;

            let $productImage = $this.closest('.product-details__row').find('.product-description__image img'),
                $selectedFlavour = $this.closest('.product-flavour').find('.product-flavour--selected'),
                $selectedStockUnits = $this.closest('.product-flavour').find('.stock-quantity__units'),
                $selectedProduct = $this.closest('.product-flavour-quantity__enclosure'),
                inStock = $this.siblings('.selected').attr('data-in-stock'),
                $selectedImage = $productImage.data('selected-image'),
                flavour = $selectedFlavour.attr('data-selected-flavour'),
                prodId = $this.siblings('.selected').attr('data-prod-id');

            if ($this.closest('.products-listing__wrapper').length) {
            } else {
                $productImage.attr('src', $selectedImage);
                $selectedFlavour.text(flavour);
                $selectedStockUnits.text(inStock);

                if(flavour == "Mixed") {
                    prodId = 'mixed'
                }
                $this.closest(".product-details__row").find(".stock-counts").addClass("hide");
                $this.closest(".product-details__row").find(`.stock-counts[data-prod-id=${prodId}]`).removeClass("hide");

                that.isOutOfStockLabel(inStock, $selectedProduct);
            }
        });

        $('body').on('click', '.flavours-listing .flavour', function(e) {
            e.preventDefault();

            let $this = $(this),
                $flavourListing = $this.closest('.flavours-listing');

            if ($this.closest('.products-listing__wrapper').length) {

                that.addProduct($this, $this);

            } else {
                let $productImage = $this.closest('.product-details__row').find('.product-description__image img'),
                    $selectedFlavour = $this.closest('.product-flavour').find('.product-flavour--selected'),
                    $selectedProduct = $this.closest('.product-flavour-quantity__enclosure'),
                    inStock = $this.attr('data-in-stock');

                $flavourListing.find('.selected').removeClass('selected');
                $this.addClass('selected');

                $productImage.data('selected-image', $this.data('image'));
                $selectedFlavour.text($this.data('name'));
                $selectedFlavour.attr('data-selected-flavour', $this.data('name'));

                 that.isOutOfStockLabel(inStock, $selectedProduct);
            }

        });

        $('body').on('keyup', '.product-details .counter-value', function() {

            that.calculatePricePerProduct();
            that.updateProducts();
            that.updatePayment();
        });
    }

    getAllProducts(isAfterLoad, showProductsPanel = true) {
        let that = this,
            institutionId = $('#InstitutionId').val(),
            isVieOrderPage = $('.view-order').length,
            isDashboard = $('section.dashboard').length,
            apiUrl;

        // console.log('checking stock');
        // console.log($('#postal_code').val());
        if(isVieOrderPage){
            let institutionId = $('#InstitutionId').val(),
                postCode = $('#postal_code').val();

            apiUrl = '/api/products/stock?institutionId='+institutionId +'&postcode='+postCode;

        }else if(isDashboard && isAfterLoad && $('#postal_code').val() !== '' && $('#postal_code').val() !== null){
            let institutionId = $('#InstitutionId').val(),
                postCode = $('#postal_code').val();

            apiUrl = '/api/products/stock?institutionId='+institutionId +'&postcode='+postCode;
        }
        /**
         *
         * TODO: after adding post code information list of products needs to be updated and the products added will receive the label.
         *
         * */
        // else if(isDashboard && isAfterLoad && $('#postal_code').val() !== '' && $('#postal_code').val() !== null){
        //     let $stockDetails = `<span class="stock-quantity__units"> </span>
			// 				<span> &nbsp; </span>
			// 				<span> unit(s) left </span>
			// 				<span class="stock-quantity__label"> Insufficient Stock </span>`;
        //
        //     //Create markup then display first order products
        //     let $regimenFirstOrder = $firstOrderProductRow.clone(true),
        //         $firstOrderFooter = $orderOverrideContainer.find('.product-details__footer');
        //     $firstOrderFooter.before($regimenFirstOrder);
        //
        //     let $orderOverrideRow = $orderOverrideContainer.find('.product-details__row');
        //
        //     for (let index =0, len = $firstOrderProductRow.length; index < len; index++){
        //         $orderOverrideRow.eq(index)
        //             .find('.stock-quantity')
        //             .html($stockDetails);
        //     }
        //
        //     $orderOverrideContainer.addClass('show');
        // }
        else{
            // apiUrl = '/api/products/products?institutionId='+institutionId; //proto
            apiUrl = '/api/products?institutionId='+institutionId;
        }

        $.ajax({
            dataType: 'json',
            url: apiUrl,
            success: function(data) {
                that._products = data;

                // needed to display list of products only for the first time, on init
                let $activePhase = $('.phase--wrapper.active'),
                    $parent = $activePhase.find('.add-products__enclosure'),
                    $list = $activePhase.find('.products-list__wrap');

                that.displayAllProducts($activePhase, $parent, $list, that._products, showProductsPanel);
            }
        });
    }

    displayAllProducts(_el, _parent, _list, _stock, showProductsPanel = true) {
        let that = this,
            $this = _el,
            $parent = _parent,
            $list = _list,
            isEditProduct = ($('.view-regimen').length || $('.view-order').length),
            $tenderSetting;

        // Handlebar template initialisation
        let $productListItemTemplateSource = $('#product-list-item').html(),
            $productListItemTemplate = Handlebars.compile($productListItemTemplateSource),
            $listId = 'dynmaiclist' + Math.round(new Date().getTime() + (Math.random() * 100)); // Random ID to us;

        //TODO: consider refactoring. This was a quick way to deal with SOH with the current codebase
        if(typeof _stock !== 'undefined')
            that._products = _stock;

        let $productDetail = $('.phase--wrapper.active .product-details:first-child .product-details__row'),
        productTypeIds = [];
        $productDetail.each(function (e) {
            let prodTypeId = $(this).data('prod-type-id');
            if($(this).data("is-special") == true) {
                prodTypeId += "_special";
            }
            if(jQuery.inArray(prodTypeId, productTypeIds) < 0 ){
                productTypeIds.push(prodTypeId);
            }
        });

        let tempProducts = [];
        for (let pIndex = 0; pIndex < that._products.length; pIndex++) {
            const prod = that._products[pIndex];
            if(prod.SortOrder != null) continue;
            let sortString = "";
            switch(prod.Category.trim()) {
                case "PAEDIATRIC NUTRITION":
                    sortString = "00";
                    break;
                case "ORAL NUTRITION":
                    sortString = "01";
                    break;
                case "DISEASE SPECIFIC NUTRITION":
                    sortString = "02";
                    break;
                case "TUBE FEEDS":
                    sortString = "03";
                    break;
                default:
                    sortString = "04"
                    break;
            }
            sortString += "_" + prod.ProductTypeId;
            prod.SortOrder = sortString;
            let tbdProd = prod.Flavours.find(f=>f.Status == "ToBeDiscontinuedWithReplacement");
            if(tbdProd != null) {
                prod.hasReplacement = true;
                let replacementProd = that._products.find(x=>x.Flavours.findIndex(f=>f.ProductId == tbdProd.ReplacementProductId) > -1);
                if(replacementProd != null) {
                    replacementProd.SortOrder = sortString + "_1";
                    prod.replacementProd = `${replacementProd.Brand} ${replacementProd.PackagingQuantity} ${replacementProd.PackagingMeasure} ${replacementProd.PackagingType}`;
                }
            }
        }

        that._products.sort((a,b)=>{
            if(a.SortOrder < b.SortOrder) {
                return -1;
            }
            if(b.SortOrder < a.SortOrder) {
                return 1;
            }
            return 0;
        });


        // Building the markup from handlebars template
        $(that._products).each(function($key, $product){
            let priceGstIncluded = $product.TenderPrice + $product.TenderPrice * $product.Gst;
            let singlePriceGstIncluded = $product.SingleUnitPrice == null ? null : ($product.SingleUnitPrice + ($product.SingleUnitPrice * $product.Gst)).toFixed(2);
            $product['price'] = priceGstIncluded.toFixed(2);
            $product['singlePrice'] = singlePriceGstIncluded;
            $product['hasSinglePrice'] = that.hasSinglePrice(singlePriceGstIncluded);
            $product['Images'] = $product.Flavours[0].Image;
            $product['StocksMixedFlavourJSON'] = JSON.stringify($product.StocksMixedFlavour);
            $product['TenderQuantityType'] = that._tenderSetting.QuantityType;
            for (let i = 0; i < $product.Flavours.length; i++) {
                const flav = $product.Flavours[i];
                flav.StocksJSON = JSON.stringify(flav.Stocks);
            }
            let prodTypeId = $product.ProductTypeId;
            if($product.IsSpecial) {
                prodTypeId += "_special";
            }
            if((jQuery.inArray(prodTypeId, productTypeIds) < 0 || (jQuery.inArray(prodTypeId, productTypeIds) >= 0 && $product.Flavours.length > 1))){
              //add normal product
              that.$productList += $productListItemTemplate($product);
            }
            // //add special product, only if it hasnt been added before and there is pricing for it
            // if($product.SpecialPrice > 0 && $product.SpecialStockMixedFlavour > 0) {
            //     prodTypeId += "_special";
            //     if(jQuery.inArray(prodTypeId, productTypeIds) < 0 || (jQuery.inArray(prodTypeId, productTypeIds) >= 0 && $product.Flavours.length > 1)){
            //         let specialPriceGstIncluded = $product.SpecialPrice + $product.SpecialPrice * $product.Gst;
            //         $product['specialprice'] = specialPriceGstIncluded.toFixed(2);
            //         $product['SpecialListing'] = true;
            //         that.$productList += $productListItemTemplate($product);
            //         $product['SpecialListing'] = false;
            //     }
            // }
        });

        // Add generated markup to container
        $list.find('.products-listing__wrapper').html(that.$productList);

        // Giver the container a unique ID, used with list.js
        $list.attr('id', $listId);

        // List.js options,
        let $options = {
            valueNames: ['name', { data: ['category'] }],
            page: $("body").hasClass("staffshop") ? 12 : 8,
            pagination: true
        };

        // Initialise list.js list with pagination
        that.$productList = new List($listId, $options);

        let $productsListingMsg = $('.products-listing__msg');
        that.$productList.on('searchComplete', function(e) {
            if (e.visibleItems.length == 0) {
                $productsListingMsg.show();
            } else {
                $productsListingMsg.hide();
            }
        }).on('filterComplete', function (e) {
            if (e.visibleItems.length == 0) {
                $productsListingMsg.show();
            } else {
                $productsListingMsg.hide();
            }
        });

        if(!isEditProduct && showProductsPanel){

            $parent.slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

            $list.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    if (that.isInit) {
                        if ($this.closest('.add-products__enclosure').next().offset() != undefined) {
                            let el = '.categories-list',
                                $header = $('.header');

                            gsap.to(window, {duration: 1, 
                                scrollTo: {
                                    y: $this.closest('.add-products__enclosure').next().offset().top - $header.outerHeight() - parseInt($header.css('top')),
                                    ease: "expo.inOut"
                                }
                            });
                        }
                    } else {
                        that.isInit = true;
                    }
                }
            });
        }

        if(isEditProduct && $this.hasClass("js-select-products")){

            $list.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    if (that.isInit) {
                        if ($this.closest('.add-products__enclosure').next().offset() != undefined) {
                            let el = '.categories-list',
                                $header = $('.header');

                                gsap.to(window, {duration: 1, 
                                scrollTo: {
                                    y: $this.closest('.add-products__enclosure').next().offset().top - $header.outerHeight() - parseInt($header.css('top')),
                                    ease: "expo.inOut"
                                }
                            });
                        }
                    } else {
                        that.isInit = true;
                    }
                }
            });
        }
    }

    addProduct($object, $selectedFlavour){
        let $parent = $($object).closest('.container'),
            $flavourListing = '',
            noOfOrders = "0";

        //get no of orders if on nutrition plan page
        if($('.phase--wrapper.active .product-details').length > 0) {
            noOfOrders = $('.phase--wrapper.active .product-details').find('.product-details__header .counter-value').val();
        }

        // Handlebar template initialisation
        let $productDetailsTemplateSource = $('#product-details-product').html(),
            $productDetailsTemplate = Handlebars.compile($productDetailsTemplateSource);

        // Building the markup from handlebars template
        let $productData = {};

        $productData['tender'] = $parent.data('tender');
        $productData['gst'] = $parent.data('gst');
        $productData['price'] = $parent.data('price');
        $productData['singlePrice'] = $parent.data('single-price');
        $productData['hasSinglePrice'] = this.hasSinglePrice($productData['singlePrice']);
        $productData['isspecial'] = $parent.data('is-special');
        // $productData['specialprice'] = $parent.data('special-price');
        $productData['quantity'] = 1;
        $productData['brand'] = $parent.data('brand');
        $productData['packagingtype'] = $parent.data('packaging-type');
        $productData['packagingquantity'] = $parent.data('packaging-quantity');
        $productData['packagingmeasure'] = $parent.data('packaging-measure');
        $productData['cartonsize'] = $parent.data('cartonsize');
        $productData['producttypeid'] = $parent.data('prod-type-id');
        $productData['splittableproduct'] = $parent.data('split-prod');
        $productData['enforcecartonqty'] = ($parent.data('tender-quantity-type') == "CartonSize" && noOfOrders != "1") && !$productData['hasSinglePrice'];
        $productData['hasReplacement'] = $parent.data('has-replacement');

        if($selectedFlavour) {
            $productData['flavour'] = $selectedFlavour.data('name');
            $productData['image'] = $selectedFlavour.data('image');
            $productData['stockquantity'] = $selectedFlavour.attr('data-in-stock');
            $productData['stocks'] = JSON.parse($selectedFlavour.attr('data-in-stocks'));
            $productData['offTender'] = $selectedFlavour.data('offtender');

            $flavourListing = $($selectedFlavour).parent().html();
        } else {
            $productData['flavour'] = $parent.find('.flavours-listing .flavour').first().data('name');
            $productData['image'] = $parent.find('.flavours-listing .flavour').first().data('image');
            $productData['stockquantity'] = $parent.find('.flavours-listing .flavour').first().attr('data-in-stock');
            $productData['stocks'] = JSON.parse($parent.find('.flavours-listing .flavour').first().attr('data-in-stocks'));
            $productData['offTender'] = $parent.find('.flavours-listing .flavour').first().data('offtender');

            $flavourListing = $($object).parent().parent().find('.flavours-listing ul').html();
        }

        let flavours = [];
        $(`<ul>${$flavourListing}</ul>`).find("li").each(function(idx, itm){
            flavours.push({
                ProductId: $(itm).data("prod-id") ?? "mixed",
                stocks: $(itm).data("in-stocks"),
                isMixed: $(itm).hasClass("mixed"),
                name: $(itm).data("name"),
                hide: $productData['flavour'] == $(itm).data("name") ? "" : "hide"
            });
        });
        $productData['flavours'] = flavours;

        let $prodDetCont = $($object).closest('.product-details.container'),
            $prodDetFoot = $prodDetCont.find('.product-details__footer');

        // Add generated markup to container
        $prodDetFoot
            .before($productDetailsTemplate($productData));

        // Append flavours
        $prodDetFoot
            .prev().find('.product-flavour ul').html($flavourListing);

        // Find the selected flavour
        $prodDetFoot
            .prev().find('.product-flavour ul .' + $productData['flavour'].toLowerCase().split(' ')[0]).addClass('selected');


        // Focus in input field
        $prodDetFoot
            .prev()
            .find('.product-quantity__value .counter-value').focus();


        // Scroll to added markup
        let $header = $('.header');
        gsap.to(window, {duration: 1, 
            scrollTo: {
                y: $($object).closest('.product-details.container').find('.product-details__footer').prev().offset().top - $header.outerHeight() - parseInt($header.css('top')),
                ease: "expo.inOut"
            },
            onComplete: function () {
                setTimeout(function () {
                    $header.removeClass('compact');
                }, 90);
            }
        });

        // Compute all the numbers
        this.calculatePricePerProduct();
        this.updateProducts();
        this.updatePayment();
        this.calculateTotalGst();

        let $selectedStockLabel = $prodDetFoot.prev().find('.stock-quantity__label');

        this.isOutOfStockLabel($productData['stockquantity'], $selectedStockLabel);

        // Close the product list
        $($object).closest('.products-list.container').find('.js-close-list').trigger('click');
    }

    updateProducts() {
        let isEditProduct = ($('.view-regimen').length || $('.view-order').length);

        let that = this,
            $productDetails,
            receiptTableRowTmp = '',
            receiptTableRowHtml = '',
            summaryProductsTableRowTmp ='',
            summaryProductsTableRowHtml = '',
            isDashboard = false,
            obj = {},
            grandTotalMonths = 0,
            grandTotalProdTypes = 0,
            grandTotal = 0,
            inc = 0;

        if($('.form--order-override').is(':visible'))
            $productDetails = $('.form--order-override .product-details');
        else
            $productDetails = $('.phase--wrapper.active .product-details');

        //check what page is displayed
        if ($('.dashboard').length){
            isDashboard = true;
            receiptTableRowTmp = doT.template($('#receipt-table-row-tmp').html())
        }

        let totalPrice = 0;

        // Go through each phase
        $productDetails.each(function (i, v) {
            let $this = $(this),
                $productPriceTotal = $this.find('.product-price__total'),
                $regimenTotalPrice = $this.find('.regimen-total__price'),
                totalPrice = 0;

            // Calculate products in each regimen
            $productPriceTotal.each(function (i, v) {
                totalPrice += Number($(this).text());
            });

            // Display regimen total
            totalPrice = totalPrice.toFixed(2);
            $regimenTotalPrice.text(totalPrice);

            // populate table
            let $product = $this.find('.product-details__row'),
                $productHeader = $this.find('.product-details__header'),
                phaseName = $this.find('h2').text(),
                numOfMonths = Number($this.find('.product-details__header .counter-value').val()),
                phaseHeader = phaseName + ' - ' + numOfMonths * 4 + " Weeks",
                productQty,
                numOfProdType = $product.length,
                productDesc = '',
                numOfWeeks = numOfMonths * 4,
                expiry,
                startDate;

            if($( "#StartToday" ).prop('checked'))
                expiry = moment().add('weeks', numOfWeeks);
            else{
                startDate = $('#StartDate').val();
                startDate = moment(startDate, 'DD-MM-YYYY'),
                expiry = moment(startDate).add('weeks', numOfWeeks);
            }

            // Check if it is a staged regimen.
            if (i > 0) {
                let $previousStage = $this.prev('.phase--wrapper.active .product-details'),
                    previousExpiry = $previousStage.find('.date').text(),
                    momentObj = moment(previousExpiry, 'DD-MM-YYYY'),
                    previousExpiryDate = momentObj.format('YYYY-MM-DD');

                    expiry = moment(previousExpiryDate).add('weeks', numOfWeeks);
            }

            $productHeader.find('.date').html(' ' + moment(expiry).format('DD-MM-YYYY'));

            if ($product.length && isDashboard) {
                grandTotalMonths += numOfMonths;
                grandTotalProdTypes += numOfProdType;

                for (let n = 0, l = numOfMonths; n < l; n++) {
                    let productDescConcat = '',
                        interval = inc + 1,
                        endInterval = interval * 4,
                        startInterval = endInterval - 3;

                    interval += ' (weeks ' + startInterval + '-' + endInterval + ')';

                    $product.each(function (i, v) {
                        productDesc = $(this).find('.product-description__title').text() + ' ' + $(this).find('.product-description__base-quantity').text();
                        let prodFlavour = $(this).find('.product-flavour--selected').text() || '';
                        if(prodFlavour != '') {
                            productDesc = `${productDesc} (${prodFlavour})`;
                        }
                        productQty = $(this).find('.product-quantity__value .counter-value').val();

                        productDescConcat += productQty + 'x ' + productDesc + '<br/>';
                    });

                    obj = {
                        'month': interval,
                        'products': productDescConcat,
                        'price': totalPrice,
                        'phase': phaseHeader
                    }

                    grandTotal += Number(totalPrice);

                    receiptTableRowHtml += receiptTableRowTmp(obj);

                    // Display products only once on the dashboard summary.
                    if (isDashboard && (n == 0)){
                        summaryProductsTableRowTmp = doT.template($('#summary--products__row-tmp').html());
                        summaryProductsTableRowHtml += summaryProductsTableRowTmp(obj);
                    }

                    inc += 1;
                }
            }
        });

        // Inject HTML
        $('.form--products .receipt tbody').html(receiptTableRowHtml);

        $('.form--products .receipt .t-lrg').html($('.phase--wrapper.active .product-details:first-child .date').text());

        $('.summary--products__enclosure').html(summaryProductsTableRowHtml);


        // Summarize Order
        $('.summary--months .num').text(grandTotalMonths * 4 );
        $('.summary--products .num').text(grandTotalProdTypes);
        $('.summary--price').text(grandTotal);

        // Set total to zero if empty
        if ($productDetails.length == 0) {
            totalPrice = 0;
            $regimenTotalPrice.text(totalPrice.toFixed(2));
        }

        that.updatePayment();


    }

    calculatePricePerProduct() {
        let that = this;
        $('.product-details__row').each(function (i, v) {
            let $this = $(this),
                $price = $this.data('price'),
                $singlePrice = $this.data('single-price'),
                $cartonSize = $this.data("cartonsize"),
                $isSpecial = $this.data('is-special'),
                $qty = $this.find('.product-quantity__value .counter-value').val(),
                $counterVal = $this.find('.counter-value'),
                $productPrice = $this.find('.product-price__total'),
                prodTotal = 0;
            
            prodTotal = that.calculateProductTotal($price, $singlePrice, $qty, $cartonSize);
            
            prodTotal = prodTotal.toFixed(2);

            $counterVal.val($qty);
            $productPrice.text(prodTotal);
        });
    }

    calculateProductTotal($price, $singlePrice, $qty, $cartonSize) {
        let prodTotal = 0,
        isQtyInCartonSize = $qty % $cartonSize == 0;
        if(!this.hasSinglePrice($singlePrice)) {
            prodTotal = $qty * $price;
        } else {
            if(isQtyInCartonSize) {
                prodTotal = $price * $qty;
            } else {
                //we need to charge the carton size quantity with package price and the remainder 
                if($qty < $cartonSize) {
                    prodTotal = $singlePrice * $qty;
                } else {
                    //this would mean qty is more than cartonSize but not in cartSize denomination
                    let remainingQty = $qty % $cartonSize;
                    let packageQty = $qty - remainingQty;
                    prodTotal = (packageQty * $price) + (remainingQty * $singlePrice);
                }
            }
        }
        return prodTotal;
    }

    //Prices displayed on listing already include gst, price = tenderPrice + GST
    //Need to calculate total GST for receipt
    calculateTotalGst() {
        let $productDetail = $('.phase--wrapper.active .product-details:first-child .product-details__row'),
            deliveryGstTot,
            gstTotal = 0,
            that = this;

        $productDetail.each(function (i, v) {
            let $this = $(this),
                $qty = $this.find('.product-quantity__value .counter-value').val(),
                $tenderPrice = $this.data('tender'),
                $singlePrice = $this.data('single-price'),
                $cartonSize = $this.data('cartonsize'),
                //$specialPrice = $this.data('special-price'),
                $isSpecial = $this.data('is-special'),
                $gst = $this.data('gst'),
                unitGst = 0,
                prodGst = 0,
                prodTotal = 0;

            prodTotal = that.calculateProductTotal($tenderPrice, $singlePrice, $qty, $cartonSize);
            unitGst = $gst * prodTotal;
            // if($isSpecial) {
            //     unitGst = $gst * $specialPrice;
            // }
            prodGst = unitGst * $qty;

            gstTotal += prodGst;
        });

        return gstTotal;
    }

    hasSinglePrice(singlePrice){
        return singlePrice > 0;
    }

    updatePayment() {
        let isEditProduct = ($('.view-regimen').length || $('.view-order').length);

        if(isEditProduct){
            return false;
        }

        let $productDetail = $('.phase--wrapper.active .product-details:first-child .product-details__row'),
            receiptDeliveryFee = Number($('.receipt--delivery-total').text()),
            paymentTableRowTmp = doT.template($('#payment-table-row-tmp').html()),
            summaryTableRowTmp = doT.template($('#summary-row-tmp').html()),
            paymentTableRowHtml = '',
            summaryTableRowHtml = '',
            numberOfCartons = 0,
            obj = {},
            totalPrice = 0,
            total = 0,
            that = this;

        let productTypeIds = [];
        $productDetail.each(function (e) {
            let prodTypeId = $(this).data('prod-type-id');
            if($(this).data("is-special") == true){
                prodTypeId += "_special";
            }
          if(jQuery.inArray(prodTypeId, productTypeIds) < 0 ){
            productTypeIds.push(prodTypeId);
          }
        });

        //products of the same product type will be shipped in the same carton
        var i;
        for(i = 0; i < productTypeIds.length; i++ ){
          let $totalProductQty = 0,
              $cartonSize,
              $productTypeNumCartons;

          $productDetail.each(function (e) {
            let pdt = $(this).data('prod-type-id');
            if($(this).data("is-special") == true){
                pdt += "_special";
            }
            if(pdt == productTypeIds[i]){
              let $this = $(this),
                  $price = Number($this.data('price')),
                  $singlePrice = Number($this.data('single-price')),
                  $productQty = Number($this.find('.product-quantity__value .counter-value').val()),
                  $productTotal = $productQty * $price,
                  $isSpecial = $this.data("is-special"),
                  $isQtyInCartonSize = $productQty % $cartonSize == 0;
            
              $cartonSize = Number($this.data('cartonsize'));
                  
              obj = {
                'product': $this.find('.product-description__title').text(),
                'price': $price,
                'qty': $productQty,
                'total': $productTotal.toFixed(2),
                'special': $isSpecial ? "special" : "normal"
              }

              let prodFlavour = $this.find('.product-flavour--selected').text() || '';
              if(prodFlavour != '') {
                obj.product = `${obj.product} (${prodFlavour})`;
              }

              if(that.hasSinglePrice($singlePrice)) {
                  if($isQtyInCartonSize) {
                      $productTotal = $productQty * $price;
                      obj.price = $price;
                  } else {
                    //this would mean qty is more than cartonSize but not in cartSize denomination
                    let remainingQty = $productQty % $cartonSize;
                    let packageQty = $productQty - remainingQty;
                    let packageTotal = (packageQty * $price);
                    let remainingProdTotal = (remainingQty * $singlePrice);
                    $productTotal = packageTotal + remainingProdTotal;

                    //we set the main obj to contain non carton sized quantities
                    obj.total = remainingProdTotal.toFixed(2);
                    obj.qty = remainingQty;
                    obj.price = $singlePrice;

                    if(packageQty > 0) {
                        //set a new line item for carton sized quantity which reflects the unit price
                        let packageObj = {
                            'product': $this.find('.product-description__title').text(),
                            'price': $price,
                            'qty': packageQty,
                            'total': packageTotal.toFixed(2),
                            'special': $isSpecial ? "special" : "normal"
                        };
                        paymentTableRowHtml += paymentTableRowTmp(packageObj);
                        summaryTableRowHtml += summaryTableRowTmp(packageObj);
                    }
                  }
              }
              
              $totalProductQty = +$totalProductQty + +$productQty;

              paymentTableRowHtml += paymentTableRowTmp(obj);
              summaryTableRowHtml += summaryTableRowTmp(obj);
              totalPrice += Number($productTotal);
            }
          });

          // Define how many cartons are required for the first order
          $productTypeNumCartons = Math.ceil($totalProductQty / $cartonSize);
          numberOfCartons = numberOfCartons + $productTypeNumCartons;
        }



        totalPrice = totalPrice.toFixed(2);
        total = Number(totalPrice) + Number(receiptDeliveryFee);
        total = total.toFixed(2);



        // set hidden input to define cartons required for the first order
        $('#first-delivery__cartons').val(numberOfCartons).trigger('change');

        $('.form--payment .receipt--items').remove();
        $('.form--payment tbody tr:nth-child(2)').before(paymentTableRowHtml);

        $('.form--payment .summary .num').text(total);

        $('.show-summary__tot').text(total);

        $('.summary-order__enclosure').html(summaryTableRowHtml);

        this.updateSummary(total, totalPrice);
    }

    updateSummary(total, totalNoFees){
        let $paymentMethod = $('#payment-method'),
            $paymentClient = $('#payment-client'),
            $paymentInstitution = $('#payment-institution'),
            $flatRule = $('#payment-flat-rule').val(),
            $reverseRule = $('#payment-reverse-rule').val(),
            $paymentReverseClient = parseFloat($('#payment-reverse-client').val()).toFixed(2),
            $paymentFlatClient = parseFloat($('#payment-flat-client').val()).toFixed(2),
            $paymentReverseInstitution = parseFloat($('#payment-reverse-institution').val()).toFixed(2),
            $paymentFlatInstitution = parseFloat($('#payment-flat-institution').val()).toFixed(2),
            $paymentAdmin = parseFloat($('#payment-administration').val()).toFixed(2),
            $paymentTransaction = parseFloat($('#payment-transaction').val()).toFixed(2),
            $paymentGst = parseFloat($('#payment-gst').val()).toFixed(2),
            $paymentDelivery = parseFloat($('#payment-delivery').val()).toFixed(2),
            $gst = $('#gst'),
            $clientAmount = $('.customer-amount'),
            $institutionAmount = $('.institution-amount'),
            paymentOption = $paymentMethod.val(),
            percentClient =  parseFloat($paymentClient.val()).toFixed(2),
            othersFees = $paymentDelivery + $paymentTransaction + $paymentAdmin + $paymentGst,
            totalClient = totalNoFees * percentClient + othersFees,
            totalClientRounded = parseFloat(totalClient).toFixed(2),
            reverseValuesArray = {},
            flatValuesArray = {};

        switch(paymentOption){
            case 'allFree':
                $clientAmount.text('$ 0');
                $institutionAmount.text('$ 0');
                break;
            case 'hospital':
                $clientAmount.text('$ 0');
                $institutionAmount.text('$ '+total);
                break;
            case 'split':
                let totalInstitution = totalNoFees * ($paymentInstitution.val());
                $clientAmount.text('$ ' + totalClientRounded);
                $institutionAmount.text('$ ' + parseFloat(totalInstitution).toFixed(2));
                break;
            case 'flat':
                flatValuesArray = flatValues($flatRule, totalNoFees, $paymentAdmin, $paymentTransaction);
                $clientAmount.text('$ ' + parseFloat(flatValuesArray.customerAmount).toFixed(2));
                $institutionAmount.text('$ ' + parseFloat(flatValuesArray.institutionAmount).toFixed(2));
                break;
            case 'reverse':
                reverseValuesArray = reverseValues($reverseRule, totalNoFees, $paymentAdmin, $paymentTransaction);
                $clientAmount.text('$ ' + parseFloat(reverseValuesArray.customerAmount).toFixed(2));
                $institutionAmount.text('$ ' + parseFloat(reverseValuesArray.institutionAmount).toFixed(2));
                break;
            case 'client':
                $clientAmount.text('$ '+total);
                $institutionAmount.text('$ 0');
                break;
        }
    }

    //prepare data for API call
    getSelectedProducts(){
        let $phases = [],
            $phaseObj = {},
            $phaseProdObj = {};

        // Generate Phases Object to be passed in AJAX
        $('.phase--wrapper.active .product-details').each(function () {
            let $this = $(this);

            $phaseObj = {};
            $phaseObj.Id = $this.data('phaseid');
            $phaseObj.NumberOfOrders = $this.find('.product-details__header .counter-value').val();
            $phaseObj.Products = [];

            $this.find('.product-details__row').each(function () {
                let $this = $(this),
                    isMixed = $this.find('.flavours-listing li[data-name="Mixed"]').hasClass('selected');

                $phaseProdObj = {};
                $phaseProdObj.Id = isMixed == true ? null : $this.find('.flavours-listing li.selected').data('prod-id');
                $phaseProdObj.ProductTypeId = $this.data('prod-type-id');
                $phaseProdObj.IsSpecial = $this.data('is-special');
                $phaseProdObj.MixedFlavour = isMixed;
                $phaseProdObj.Quantity = $this.find('.product-quantity__value .counter-value').val();
                $phaseProdObj.Sku = $this.find('.flavours-listing li.selected').data('sku');

                $phaseObj.Products.push($phaseProdObj);
            });

            $phases.push($phaseObj);
        });

        return $phases;
    }

    isOutOfStockLabel(inStock, $selected){
        let isSufficient ,
            $selectedStockLabel = $selected.find('.stock-quantity__label'),
            $selectedQuantityInput = $selected.find('.counter-value'),
            selectedQuantity = Number($selectedQuantityInput.val());

        isSufficient = selectedQuantity > inStock ? false : true;

        if(inStock === 0 || !isSufficient){
            $selectedStockLabel
                .addClass('show');
        }
        else{
            $selectedStockLabel
                .removeClass('show');
        }
    }

    isThereOneOrLessOrders() {
        
        let $productDetails,
            numOfOrders = 0,
            isDashboard = false;

        if($('.form--order-override').is(':visible'))
            $productDetails = $('.form--order-override .product-details');
        else
            $productDetails = $('.phase--wrapper.active .product-details');

        //check what page is displayed
        if ($('.dashboard').length){
            isDashboard = true;
        }

        $productDetails.each(function () {
            
            let numOfMonths = Number($(this).find('.product-details__header .counter-value').val()),
                $product = $(this).find('.product-details__row');
            
            if ($product.length && isDashboard) {
                numOfOrders += numOfMonths;
            }
        });

        return numOfOrders <= 1;
    }
}